(() => {
  const form = document.querySelector('[data-public-profile-form]');
  if (!form) return;

  const status = form.querySelector('[data-public-profile-status]');
  const submit = form.querySelector('button[type="submit"]');

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (!form.reportValidity()) return;

    const data = new FormData(form);
    const attributes = {
      'Nombre completo': String(data.get('profile_name') || '').trim(),
      'DNI o NIE': String(data.get('profile_dni') || '').trim().toUpperCase(),
      'Teléfono': String(data.get('profile_phone') || '').trim(),
      'Email de contacto': String(data.get('profile_email') || '').trim(),
      'Dirección': String(data.get('profile_address') || '').trim(),
      'Código postal': String(data.get('profile_postal') || '').trim(),
      'Ciudad': String(data.get('profile_city') || '').trim(),
      'Provincia': String(data.get('profile_province') || '').trim(),
      'País': 'España'
    };

    submit.disabled = true;
    submit.setAttribute('aria-busy', 'true');
    status.textContent = "Saving your file…";

    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes })
      });
      if (!response.ok) throw new Error("We could not save your details.");
      window.location.assign(form.dataset.loginUrl);
    } catch (error) {
      status.textContent = error.message || "We could not save your details. Please try again.";
      submit.disabled = false;
      submit.removeAttribute('aria-busy');
    }
  });
})();
